export default __webpack_public_path__ + "static/media/profilePic.35b50347.jpg";